import { Switch } from 'react-router-dom';
// import AllUsers from './page';
import AllAlmaXStudents from './AllAlmaXStudents';
// import UserDetails from './user-details/page';
import UserDetails from './student-details/page';
import ProtectedRoute from '../../../extras/ProtectedRoute';
import ShowAbcatDetails from './student-details/_tabs/progress/ShowAbcatDetails';


export default function AllAlmaxStudentRouter() {
  return (
    <Switch>
      <ProtectedRoute path='/all-almax-students' exact component={AllAlmaXStudents} />
      <ProtectedRoute
        exact
        path='/all-almax-students/user-details'
        component={UserDetails}
      />
      <ProtectedRoute
        exact
        path='/all-almax-students/user-details/:id'
        component={ShowAbcatDetails}
      />
    </Switch>
  );
}
